import { environment } from '../../../environments/environment';

export var apiLinks = {
  isoCodes: `${environment.apiUrl}/isocodes`,
  securityCheck: `${environment.apiUrl}/security-check`,
  deviceUrl: `${environment.apiUrl}/tpns`,
  suggestHaciendaMid: `${environment.apiUrl}/tpns/haciendaMid/suggest`,
  deviceNameUrl: `${environment.apiUrl}/allTpns`,
  tapTpns: `${environment.apiUrl}/allTapTpns`,
  templateJsonUrl: `${environment.steamApiUrl}/getTemplateJson`,
  valueJsonUrl: `${environment.steamApiUrl}/tpn-details`,
  ticketTxn: `${environment.steamApiUrl}/additionalAuthTpnDetails`,
  receiptDetails: `${environment.steamApiUrl}/receipt-details`,
  customerReceipt: `${environment.steamApiUrl}/customer-receipt-details`,
  receiptAlterDetails: `${environment.steamApiUrl}/alter-receipt-details`,
  customerAlterReceipt: `${environment.steamApiUrl}/alter-customer-receipt-details`,
  txExtns: `${environment.apiUrl}/txExtn`,
  txAltExtn: `${environment.apiUrl}/tx-alter-extn`,
  latestBuilds: `${environment.steamApiUrl}/latest-builds`,
  checkSum: `${environment.steamApiUrl}/check-sum`,
  vtPosparam: `${environment.steamApiUrl}/vtPosparam`,
  getPosParams: `${environment.paymentApiUrl}/getPosParams`,
  processTransaction: `${environment.apiUrl}/validate-process-txn`,
  processTransactionTipAdjust: `${environment.apiUrl}/validate-process-txn-tip-adjust`,
  // processTransaction: `${environment.paymentApiUrl}/process-transaction`,
  registerDomains: `${environment.paymentApiUrl}/registerOriginswithftd`,
  cardUpdater: `${environment.apiUrl}/cardUpdater`,
  registerDomainUrls: `${environment.apiUrl}/registerDomainUrls`,
  generateWoocomKey: `${environment.apiUrl}/generateWoocomKey`,
  saveWoocomKey: `${environment.apiUrl}/saveWoocomKey`,
  getWooConfig: `${environment.apiUrl}/getWooConfig`,
  getIso3DSecureDetails: `${environment.apiUrl}/getIso3DSecureDetails`,
  paymentForm: `${environment.paymentApiUrl}/payment-form`,
  externalPaymentForm: `${environment.paymentApiUrl}/external-payment-transaction`,
  internalPaymentForm: `${environment.paymentApiUrl}/internal-payment-transaction`,
  getAllDomainNames: `${environment.paymentApiUrl}/getAllOringins`,
  pockytRefund: `${environment.pockytApiUrl}/refund-request`,
  getAllOrigins: `${environment.apiUrl}/getDomainUrls`,
  sendEmailorSMS: `${environment.apiUrl}/sendEmailorSMS`,
  openBatch: `${environment.apiUrl}/open-batch-report`,
  getOpenBatchByStore: `${environment.apiUrl}/get-open-batch-by-store`,
  getOpenBatchTpn: `${environment.apiUrl}/get-open-batch-tpn`,
  adjustTip: `${environment.apiUrl}/txn-details-portal`,
  batches: `${environment.apiUrl}/batches`,
  posEntry: `${environment.apiUrl}/posEntry`,
  posEntryTransaction: `${environment.apiUrl}/posEntryTransaction`,
  allTansData: `${environment.apiUrl}/transReport`,
  distCustomerDba: `${environment.apiUrl}/customersDBA`,
  isvNames: `${environment.steamApiUrl}/isvs/search`,
  tpnIds: `${environment.apiUrl}/getAllTpnIds`,
  dbaBatches: `${environment.apiUrl}/dba-batches`,
  dbaTotalBatches: `${environment.apiUrl}/total-dba-batches`,
  allDBAsByUser: `${environment.apiUrl}/getAllDbasByUser`,
  settleBatch: `${environment.paymentApiUrl}/process-transaction`,
  saveAsTemplate: `${environment.steamApiUrl}/pos-template`,
  templateNames: `${environment.steamApiUrl}/pos-template-names`,
  applyTemplate: `${environment.steamApiUrl}/apply-pos-template`,
  deleteTemplateParam: `${environment.steamApiUrl}/delete-template-param`,
  txBaseExtnsId: `${environment.apiUrl}/txBaseExtn`,
  pinpanTpnDevices: `${environment.apiUrl}/pinpad-tpn-devices`,
  pinpadTpns: `${environment.apiUrl}/pinpad-tpns`,
  editCards: `${environment.apiUrl}/editConsumerCards`,
  createConsumerWithoutCard: `${environment.apiUrl}/createConsumerWithoutCard`,
  updateConsumerWithoutCardApi: `${environment.apiUrl}/updateConsumerWithoutCardApi`,
  createTpn: `${environment.apiUrl}/tpns`,
  updateIsvTpnMapping: `${environment.apiUrl}/isv-tpn-mapping`,
  updateTip: `${environment.apiUrl}/updateTipAdjust`,
  createInvoice: `${environment.apiUrl}/createInvoice`,
  updateInvoiceDetails: `${environment.apiUrl}/updateInvoiceDetails`,
  getInvoice: `${environment.apiUrl}/getAllInvoice`,
  getInvoiceV2: `${environment.apiUrl}/getAllInvoiceV2`,
  downloadInvoicesV2: `${environment.apiUrl}/downloadInvoicesV2`,
  updateExpiryInvoice: `${environment.apiUrl}/updateExpiryInvoice`,
  updateGhppTag: `${environment.apiUrl}/updateGhppTag`,
  getAlltickets: `${environment.apiUrl}/getAlltickets`,
  getSamelevelUsers: `${environment.apiUrl}/get-samelevel-users`,
  updateTicketActions: `${environment.apiUrl}/update-ticket-actions`,
  addComments: `${environment.apiUrl}/add-comments`,
  getAllComments: `${environment.apiUrl}/get-all-comments`,
  getHelpdeskEmails: `${environment.apiUrl}/get-helpdesk-emails`,
  updateHelpdeskEmails: `${environment.apiUrl}/update-helpdesk-emails`,
  uploadInvoice: `${environment.apiUrl}/uploadInvoice`,
  uploadAsset: `${environment.steamApiUrl}/uploadAsset`,
  exportFile: `${environment.apiUrl}/exportFile`,
  updateCustomer: `${environment.apiUrl}/editCustomer`,
  checkJobTitle: `${environment.apiUrl}/checkJobTitle`,
  tpnBatches: `${environment.apiUrl}/tpn-batches`,
  getAllUserCount: `${environment.apiUrl}/usersCount`,
  storeDbas: `${environment.apiUrl}/getAllStoreDbasByUser`,
  isoCheckOpenBatch: `${environment.apiUrl}/isoCheckOpenBatch/`,
  getMerchantRoleFeature: `${environment.apiUrl}/getMerchantRoleFeature/`,
  getMerchantRoleFeaturUser: `${environment.apiUrl}/getMerchantRoleFeature-user/`,
  getStoreById: `${environment.apiUrl}/stores`,
  getAllStoreById: `${environment.apiUrl}/allStores`,
  getAuthKeys: `${environment.apiUrl}/getApiKeySecretKey`,
  postAuthKeys: `${environment.apiUrl}/generateApiKeySecretKey`,
  getIntegratorList: `${environment.apiUrl}/getIntegratorList`,
  postFortellisList: `${environment.apiUrl}/postFortellisList`,
  getFortellisList: `${environment.apiUrl}/getFortellisList`,
  getPockytList: `${environment.apiUrl}/getPockytList`,
  postPockytList: `${environment.apiUrl}/postPockytList`,
  getFortellisDetails: `${environment.paymentApiUrl}/externalIntegration`,
  getCloudPosConfig: `${environment.apiUrl}/getCloudPosConfig`,
  getStoreType: `${environment.apiUrl}/getStoreType`,
  pinpadTransaction: `${environment.apiUrl}/pinpad-txn`,
  deleteTpn: `${environment.apiUrl}/deleteTpn`,
  checkRecurringPaymentsTPNDeletion: `${environment.apiUrl}/checkRecurringPaymentsTPNDeletion`,
  isoDeleteMerchant: `${environment.apiUrl}/isoDeleteMerchant`,
  updateEnv: `${environment.apiUrl}/updateHostedEnv`,
  getEnv: `${environment.apiUrl}/getHostedEnv`,
  deleteStore: `${environment.apiUrl}/deleteStore`,
  deviceModels: `${environment.apiUrl}/device-models`,
  deviceModelsFiltered: `${environment.steamApiUrl}/device-models-filtered`,
  deactivatedMerchants: `${environment.apiUrl}/deactivatedMerchants`,
  getNTTPNdetails: `${environment.apiUrl}/getNTTPNdetails`,
  getManufacturer: `${environment.apiUrl}/manufacturers`,
  updateDefaultLabel: `${environment.apiUrl}/updateDefaultLabel`,
  getAllProfiles: `${environment.apiUrl}/profiles`,
  getAllProcessors: `${environment.apiUrl}/processors`,
  getIntegrationList: `${environment.apiUrl}/getIntegrationList`,
  settlementEmailAlert: `${environment.apiUrl}/settlementEmailAlertConfig`,
  recurringPaymentEmailAlertConfig: `${environment.apiUrl}/recurringPaymentEmailAlertConfig`,
  cloudPosEmailOrPasswordConfig: `${environment.apiUrl}/cloudPosEmailOrPasswordConfig`,
  sendEmailWhileSettlement: `${environment.apiUrl}/sendEmailWhileSettlement`,
  getMerchantById: `${environment.apiUrl}/merchant`,
  getMerchantLogo: `${environment.apiUrl}/merchantLogo`,
  isRPFeeApplied: `${environment.apiUrl}/isRPFeeApplied`,
  isRPForConsumer: `${environment.apiUrl}/isRPForConsumer`,
  secureDownload: `${environment.apiUrl}/secureDownload`,
  deleteMultipleTPN: `${environment.apiUrl}/deleteMultipleTpn`,
  getCustomerById: `${environment.apiUrl}/customer`,
  generateTpn: `${environment.apiUrl}/generateTPN/`,
  getEmails: `${environment.apiUrl}/secPass-users`,
  getDeviceEventTypes: `${environment.steamApiUrl}/event-types`,
  generateToken: `${environment.apiUrl}/generateToken`,
  generateGhppUrl: `${environment.apiUrl}/generateGhppUrl`,
  generateTapToken: `${environment.apiUrl}/generateTapToken`,
  verifyEmailOfMerchantAdmin: `${environment.apiUrl}/verifyEmailOfMerchantAdmin`,
  spinRegister: `${environment.steamApiUrl}/spinRegister`,
  latestBuildForBulkAssign: `${environment.apiUrl}/checkBulkAssignBuild`,
  updateBulkAssign: `${environment.apiUrl}/bulkAssignBuild`,
  buildForBulkEdit: `${environment.apiUrl}/checkBulkEditParam`,
  getAllBillingInvoice: `${environment.apiUrl}/billingInvoice`,
  getAllAuditLogs: `${environment.apiUrl}/get-all-audit-logs`,
  getAllAuditLogsPagination: `${environment.apiUrl}/get-all-audit-logs-pagination`,
  getSelectedTPNLog: `${environment.apiUrl}/get-selected-tpn`,
  posParamsDisplayNames: `${environment.steamApiUrl}/posParamDisplayNames`,
  createNote: `${environment.apiUrl}/createNotes`,
  viewNotes: `${environment.apiUrl}/listNotes`,
  processorBytxn: `${environment.apiUrl}/getProcessorsByTxn`,
  getUserById: `${environment.apiUrl}/users/`,
  getAllTpnIdsForProxyTest: `${environment.apiUrl}/getAllTpnIdsForProxyTest`,
  spinInfo: `${environment.steamApiUrl}/spinInfo`,
  regProxyTest: `${environment.steamApiUrl}/spinRegProxyTest`,
  proxyGetSerialNumberTest: `${environment.steamApiUrl}/spinTestSerialNumber`,
  clientEmailAlert: `${environment.apiUrl}/client-email-alert`,
  getTemplateJson: `${environment.steamApiUrl}/getTemplateJson`,
  bulkUpdateTemplateJson: `${environment.apiUrl}/bulkUpdateParam`,
  commitInvoice: `${environment.apiUrl}/commitInvoice`,
  updatePriorityId: `${environment.apiUrl}/updatePriorityId`,
  downloadBillInvoicePDF: `${environment.apiUrl}/downLoadInvoicePDF`,
  setupRecurringPayment: `${environment.apiUrl}/addRecurringPayment`,
  setupAlternateRecurringPayment: `${environment.apiUrl}/addAlternateRecurringPayment`,
  setupAlternateRecurringPaymentNonPaya: `${environment.achApiUrl}/createAlternateRecurringPayment`,
  getRecurringPaymentsList: `${environment.apiUrl}/getRecurringPaymentsList`,
  editRecurringPayment: `${environment.apiUrl}/getRecurringPaymentDetails`,
  editAlternateRecurringPayment: `${environment.apiUrl}/getAlternateRecurringPaymentDetails`,
  getExportsRecurringPaymentsList: `${environment.apiUrl}/getExportsRecurringPaymentsList`,
  cancelRecurringPayments: `${environment.apiUrl}/cancelRecurringPayment/`,
  getRecurringTransactions: `${environment.apiUrl}/getRecurringTransactions/`,
  customersByApplication: `${environment.steamApiUrl}/customers-application/`,
  updateCustomerToApp: `${environment.steamApiUrl}/updateCustomerToApp/`,
  updateCustomerIdInApp: `${environment.steamApiUrl}/updateCustomerIdInApp/`,
  openBatchWithreport: `${environment.apiUrl}/open-batch-filter-portal`,
  batchDetailsFilterPortal: `${environment.apiUrl}/batch-details-filter-portal`,
  transactions: `${environment.apiUrl}/transactions`,
  exportDownloadLogs: `${environment.steamApiUrl}/downloadDownloadLogsReport`,
  getAllDownloadLogs: `${environment.steamApiUrl}/getAllDownloadLogs`,
  getMoreDownloadLogs: `${environment.steamApiUrl}/getMoreDownloadLogs/`,
  downloadLogData: `${environment.apiUrl}/elasticsearchQuery/DownloadLogData`,
  downloadLogDownload: `${environment.apiUrl}/elasticsearchQuery/DownloadLogDownload`,
  downloadLogDownloadStatus: `${environment.apiUrl}/elasticsearchQuery/DownloadLogDownloadStatus?v2=true`,
  downloadLogRemoveDownloadFile: `${environment.apiUrl}/elasticsearchQuery/DownloadLogRemoveDownloadFile`,
  downloadLogCancelDownloadFile: `${environment.apiUrl}/elasticsearchQuery/DownloadLogCancelDownloadFile`,
  batchTippedReportPortal: `${environment.apiUrl}/batch-tipped-report-portal`,
  getTotalBatchByCustomer: `${environment.apiUrl}/getTotalBatchByCustomer`,
  getCustomerLogoByCustomerId: `${environment.apiUrl}/getCustomerLogoByCustomerId`,
  editCustomerLogo: `${environment.apiUrl}/editCustomerLogo`,
  countLogoImage: `${environment.steamApiUrl}/countLogoImage`,
  templateTypes: `${environment.steamApiUrl}/templateTypes`,
  spinProxyLogs: `${environment.steamApiUrl}/spinProxyLogs`,
  viewSpinProxyReqRes: `${environment.steamApiUrl}/viewSpinProxyReqRes`,
  getAllProxyLoginLogs: `${environment.apiUrl}/proxyLoginLogs`,
  getSelectedProxyDetails: `${environment.apiUrl}/selectedEmailProxyLogs`,
  setProxyLogOutTime: `${environment.apiUrl}/updateProxyLoginLogout`,
  pagoReg: `${environment.steamApiUrl}/pagoReg`,
  proxyEmailLoginAlertConfig: `${environment.apiUrl}/proxyEmailLoginAlertConfig`,
  getProxyAlertDetails: `${environment.apiUrl}/getProxyAlertDetails`,
  isEnableProxyEmailAlert: `${environment.apiUrl}/isEnableProxyEmailAlert`,
  getStoreUsers: `${environment.apiUrl}/getStoreUsers`,
  changeStore: `${environment.apiUrl}/changeStore`,
  postFortellisListParams: `${environment.apiUrl}/postFortellisListParams`,
  checkFortellisIntegration: `${environment.apiUrl}/checkFortellisIntegration`,
  payaAchGetTerminalSettings: `${environment.apiUrl}/GetCertificationTerminalSettings`,
  getWebhookUrl: `${environment.apiUrl}/generateKey-webhook`,
  preAuthenticationUrl: `${environment.apiUrl}/preAuthentication-webhook`,
  saveUrl: `${environment.apiUrl}/saveFeed-webhook`,
  getwebhookData: `${environment.apiUrl}/getfeedData`,
  updateFeedUrl: `${environment.apiUrl}/updateFeed-webhook`,
  // ISV Settings — Feed webhook config, same shape as the ISO endpoints above, backed by
  // portal-backend's routes/isvSettings.js (mounted at /v1/isv-settings).
  getIsvWebhookUrl: `${environment.apiUrl}/isv-settings/generateKey-webhook`,
  preAuthenticationIsvUrl: `${environment.apiUrl}/isv-settings/preAuthentication-webhook`,
  saveIsvFeedUrl: `${environment.apiUrl}/isv-settings/saveFeed-webhook`,
  getIsvWebhookData: `${environment.apiUrl}/isv-settings/getfeedData`,
  updateIsvFeedUrl: `${environment.apiUrl}/isv-settings/updateFeed-webhook`,
  //Promotions General Api Links
  getAllPromotions: `${environment.apiUrl}/promotions`,
  getSelectedPromotionDetails: `${environment.apiUrl}/promotionDetails`,
  addPromotions: `${environment.apiUrl}/promotions`,
  updatePromotions: `${environment.apiUrl}/promotions`,
  deletePromotion: `${environment.apiUrl}/promotions`,
  toggleStatus: `${environment.apiUrl}/change-active-status`,

  // Promotions Filter Api Links
  getPromotionCustomerFilter: `${environment.apiUrl}/customers-filter`,
  getPromotionMerchantFilter: `${environment.apiUrl}/merchants-filter`,
  getPromotionTPNsFilter: `${environment.apiUrl}/tpns-filter`,
  getPromotionIsvTPNsFilter: `${environment.apiUrl}/isv-tpns-filter`,
  getApplyForFilter: `${environment.apiUrl}/filterDetailsById`,
  generateApiKey: `${environment.apiUrl}/generateApiKey`,
  // Inventory Items , L2 and L3 Api Links
  inventoryItems: (id: string) => `${environment.apiUrl}/inventory/items/${id}`,
  l2l3Data: `${environment.apiUrl}/l2l3`,
  getAchProcessorData: `${environment.apiUrl}/getAllAchProcessor`,
  getAllAchProcessorData: `${environment.apiUrl}/getAllAchProcessorIso`,
  createAchProcessorData: `${environment.apiUrl}/createAchProcessor`,
  createAlternateProcessorIso: `${environment.apiUrl}/createachProcessorIso`,
  processACHTx: `${environment.apiUrl}/processACHTx`,
  processVoidACHTx: `${environment.apiUrl}/processVoidACHTx`,
  getDeviceInfoByTpn: `${environment.apiUrl}/getDeviceInfoByTpn`,
  getAllAlternateProcessorIso: `${environment.apiUrl}/getAllAlternateProcessorIso`,
  getTerminalTypeHistoryTxn: `${environment.apiUrl}/getTerminalTypeHistoryTxn`,
  getAllConsumers: `${environment.apiUrl}/consumerByStore`,
  suggestConsumersV2: `${environment.apiUrl}/consumerByStoreV2`,
  getConsumerPaymentOptionsV2: `${environment.apiUrl}/getConsumersTokenV2`,
  getInvoiceById: `${environment.apiUrl}/getInvoice`,
  updatedInvoiceById: `${environment.apiUrl}/updateInvoiceById`,
  getAllIsoPreferences: `${environment.apiUrl}/getIsoPreferences`,
  resendReceiptFromPortal: `${environment.apiUrl}/resendReceiptFromPortal`,
  DeleteCustomer: `${environment.apiUrl}/deleteConsumer`,
  deleteLogoFromTpns: `${environment.steamApiUrl}/deleteLogo`,
  getOwnershipInfoByTpn: `${environment.apiUrl}/getOwnershipInfoByTpn`,
  getAllAsset: `${environment.steamApiUrl}/getAllAsset`,
  rentalReplacementAsset: `${environment.steamApiUrl}/rentalReplacement`,
  stopRental: `${environment.steamApiUrl}/stopRental`,
  commitRentalInvoice: `${environment.apiUrl}/commitRentalInvoice`,
  getMerchantUsers: `${environment.apiUrl}/getMerchantUsers`,
  getSystemUsers: `${environment.apiUrl}/getSystemUsers`,
  zipCodes: `${environment.apiUrl}/zipcodes`,
  replaceMerchantEmail: `${environment.apiUrl}/replaceMerchantEmail`,
  replaceCustomerEmail: `${environment.apiUrl}/replaceCustomerEmail`,
  replaceISOEmail: `${environment.apiUrl}/isoEmailChange`,
  checkPendingInvoices: `${environment.apiUrl}/checkPendingInvoices`,
  getTerminalTypeTxn: `${environment.apiUrl}/getTerminalTypeTxn`,
  quickbooks: {
    auth: `${environment.apiUrl}/externalServices/qb/auth`,
    isQBEnabled: `${environment.apiUrl}/externalServices/qb/isQuickbooksEnabled`,
    getAllLineItems: `${environment.apiUrl}/externalServices/qb/itemsAndAccounts`,
    submitLineItems: `${environment.apiUrl}/externalServices/qb/salesReceipt`,
    submitInvoiceLineItems: `${environment.apiUrl}/externalServices/qb/payment`,
    checkLineItems: `${environment.apiUrl}/externalServices/qb/isQuickbooksEnabled`,
    qbUpdateOrDelete: `${environment.apiUrl}/externalServices/qb/`,
    getAllCustomers: `${environment.apiUrl}/externalServices/qb/customers?all=true`,
    getInvoiceById: `${environment.apiUrl}/externalServices/qb/invoice`,
    getCustomerById: `${environment.apiUrl}/externalServices/qb/customer`,
    refund: `${environment.apiUrl}/externalServices/qb/refund`,
    voidQb: (type: string, isPartial: boolean) => `${environment.apiUrl}/externalServices/qb/${type}/${isPartial ? 'partial' : 'void'}`,

  },
  PayaAch:{
    GetCertificationTerminalSettings:`${environment.apiUrl}/GetCertificationTerminalSettings`,
    ProcessSingleCertificationCheck:`${environment.apiUrl}/ProcessSingleCertificationCheckPortal`,
    ppdAndCcd:`${environment.apiUrl}/ppdAndCcd`,
    addAch:`${environment.apiUrl}/add-ach`,
    addAchCheck:`${environment.apiUrl}/add-ach-check`,
    ProcessSingleCertificationCheckCloudPos:`${environment.apiUrl}/ProcessSingleCertificationCheckCloudPos`,
  },
  merchantSettings: {
    settings: `${environment.apiUrl}/merchantNotifications`,
    getUniqueLabels: `${environment.steamApiUrl}/uniqueTpnLabels`,
    uploadMerchantAndStoreLogos: `${environment.apiUrl}/uploadMerchantAndStoreLogos`,
    getMerchantAndStoreLogos: `${environment.apiUrl}/getMerchantAndStoreLogos`,
    getApplePayDomains: `${environment.apiUrl}/wallet-registration/list`,
    addApplePayDomain: `${environment.apiUrl}/addApplePayDomain`,
    sampleDomainFile: `${environment.apiUrl}/domain-file`

  },
  report: {
    tip: `${environment.apiUrl}/report`,
    tipTagValue: `${environment.apiUrl}/report/tagValue`,

  },
  getAllStoreByEmailId: `${environment.apiUrl}/getStoresByEmail`,
  receipt: {
    card: `${environment.steamApiUrl}/customer-receipt-details`,
    alternate: `${environment.steamApiUrl}/alter-customer-receipt-details`,
    viewReceiptNoAuth: `${environment.steamApiUrl}/receipt`,
    viewReceiptNoAuthBackend: `${environment.apiUrl}/receipt`,
  },
  updateRefundFlag: `${environment.apiUrl}/updateRefundFlag`,
  generateOneTimePasscode: `${environment.apiUrl}/generateOneTimePasscode`,
  getAllUniqueBuildFromApp: `${environment.apiUrl}/getAllUniqueBuildFromApp`,
  getAllUniqueDeviceModelFromApp: `${environment.apiUrl}/getAllUniqueDeviceModelFromApp`,
  getAllUniqueTemplateFromApp: `${environment.apiUrl}/getAllUniqueTemplateFromApp`,
  getAllUniqueCustomersFromApp: `${environment.apiUrl}/getAllUniqueCustomersFromApp`,
  advancedAssignBuild: `${environment.apiUrl}/advancedAssignBuild`,
  getAllMerchants: `${environment.apiUrl}/get-merchants`,
  getAllTpnIds: `${environment.apiUrl}/getAllTpnIds`,
  riskRules: {
    risk: `${environment.apiUrl}/riskRule`,
    activateTpn: `${environment.apiUrl}/riskRule/activateTpn`,
    template: `${environment.apiUrl}/riskRule/template`,
    bulkUpdate: `${environment.apiUrl}/riskRule/bulkUpdate`
  },
  alterativePayments: `${environment.apiUrl}/alternative-payments`,
  signUploadAlternativePayments: `${environment.apiUrl}/tx-alter-extn-portal`,
  inventory: `${environment.apiUrl}/inventory`,
  updateInventoryStatus: `${environment.apiUrl}/inventory/update-inventory-status`,
  inventoryTransactions: `${environment.apiUrl}/inventory/transactions`,
  inventoryReportDownload: `${environment.apiUrl}/inventory/transactions/download`,
  getPayaStates: `${environment.apiUrl}/payaStatesPortal`,
  getHsmToken: `${environment.apiUrl}/getHsmToken`,
  checkIsPayaMerchant: `${environment.apiUrl}/checkIsPayaMerchant`,
  saveEmailForReportDownload: `${environment.apiUrl}/saveEmailForReportDownload`,
  alternateVoid: `${environment.apiUrl}/alternate/void`,
  payaPayload: `${environment.apiUrl}/payaPayload`,
  getExternalIntegrationList: `${environment.apiUrl}/getExternalIntegrationList`,
  getAllFortellisTransactionIds: `${environment.apiUrl}/getAllFortellisTransactionIds`,
  ppiPushApi:`${environment.apiUrl}/ppiPushApi`,
  marketApp:{
    uploadMarket:`${environment.steamApiUrl}/uploadMarketApp/`,
    editMarket:`${environment.steamApiUrl}/editMarketApp/`,
    getAllApps:`${environment.steamApiUrl}/getAllMarketApps/`,
    deleteMarket:`${environment.steamApiUrl}/deleteMarketApp/`,
  },
  appMasterList:`${environment.steamApiUrl}/appMasterList/`,
  appMasterVersionList:`${environment.steamApiUrl}/appMasterVersionList/`,
  updateAnchorAppByAssetId:`${environment.steamApiUrl}/updateAnchorAppByAssetId/`,
  checkThirdPartyAppByCustomer:`${environment.steamApiUrl}/checkThirdPartyAppByCustomer/`,
  getAllThirdPartyAppByTpn:`${environment.steamApiUrl}/getAllThirdPartyAppByTpn/`,
  getAllThirdPartyAppByCustomer:`${environment.steamApiUrl}/getAllThirdPartyAppByCustomer/`,
  getAllThirdPartyApp:`${environment.apiUrl}/getAllThirdPartyApp/`,
  getIsvThirdPartyAppsByTpn:`${environment.steamApiUrl}/getIsvThirdPartyAppsByTpn/`,
  checkIsvThirdPartyAppByCustomer:`${environment.steamApiUrl}/checkIsvThirdPartyAppByCustomer/`,
  getIsvThirdPartyAppForModal:`${environment.steamApiUrl}/getIsvThirdPartyAppForModal/`,
  saveThirdPartyApp:`${environment.steamApiUrl}/saveThirdPartyApp/`,
  saveIsvThirdPartyApp:`${environment.steamApiUrl}/saveIsvThirdPartyApp/`,
  ecomAuthToken:`${environment.apiUrl}/extra/ecomAuthToken/`,
  createNonGatewayTPN:`${environment.steamApiUrl}/non-gateway-web/tpn/`,
  updateNonGatewayTPN:`${environment.steamApiUrl}/non-gateway-web/tpn/`,
  getAllNonGatewayTPN:`${environment.steamApiUrl}/non-gateway-web/`,
  deleteNonGatewayTPN:`${environment.steamApiUrl}/non-gateway-web`,
  mfa: {
    validate: `${environment.apiUrl}/mfa/validateLogin`,
    resendOTP: `${environment.apiUrl}/mfa/resendOTP`,
    verifyOTP: `${environment.apiUrl}/mfa/verifyOTP`,
    updateStatus: `${environment.apiUrl}/mfa/updateMfa`,
    userCreateOTPVerify: `${environment.apiUrl}/mfa/userCreateOTPVerify`,
    userUpdateOTPVerify: `${environment.apiUrl}/mfa/userUpdateOTPVerify`,
    pxyLoginOTPVerify: `${environment.apiUrl}/mfa/pxyLoginOTPVerify`,
    resendOTPWithUiRefId: `${environment.apiUrl}/mfa/resendOTPWithUiRefId`,
    processTxnOTPVerify: `${environment.apiUrl}/mfa/processTxnOTPVerify`,
    totpVerify: `${environment.apiUrl}/mfa/totp/verify`,
    totpVerifySetup: `${environment.apiUrl}/mfa/totp/verify-setup`,
  },
  validateUser:`${environment.apiUrl}/validate-user`,
  validateUpdateUser:`${environment.apiUrl}/validate-update-user`,
  validatePxyLogin:`${environment.apiUrl}/validate-pxy-login`,
  getWhitelabelInfo:`${environment.apiUrl}/getWhitelabelInfo`,
  fileDownload: (ref: string) => `${environment.apiUrl}/download/file/${ref}`,

  getIntegrationsUrl: `${environment.apiUrl}/getMerchantIntegrationList`,

  cardinalMerchant: `${environment.apiUrl}/cardinalMerchant`,

  extraThreeSixty: {
    deleteExtraTpn: `${environment.apiUrl}/extra/deleteExtraTpn`,
    createExtra360Store: `${environment.steamApiUrl}/extra/createUpdateExtraStore`,
    createExtra360Merchant : `${environment.apiUrl}/extra/createUpdateExtraMerchant`,
    updateMerchantPreferenceMapping : `${environment.apiUrl}/extra/updateMerchantPreferenceMapping`,
    checkStore360Integration : `${environment.apiUrl}/extra/checkMerchantStoreIntegration`,
    deleteExtra360Merchant: `${environment.apiUrl}/extra/deleteExtraMerchant`,
    deleteExtra360Store: `${environment.apiUrl}/extra/deleteExtraStore`,
  },
  getUniqueCustomerId:`${environment.apiUrl}/getUniqueCustomerId`,
  checkAssetProtection:`${environment.steamApiUrl}/checkAssetProtection`,
  downloadAllAsset:`${environment.steamApiUrl}/downloadAllAsset`,
  getSelectedAssetCount:`${environment.steamApiUrl}/getSelectedAssetCount`,
  bulkFirmwareUpdate:`${environment.steamApiUrl}/bulkFirmwareUpdate`,
  sampleAssetUpload: `${environment.apiUrl}/sample-upload-asset`,
  viewUploadedInvoice: `${environment.apiUrl}/viewUploadedInvoice`,
  getAllDvStoreThirdPartyApp:`${environment.steamApiUrl}/third-party-apps/all-apps`,
  getThirdPartyAppById:`${environment.steamApiUrl}/third-party-apps/get-app`,
  thirdPartyAppsUpdateCheck:`${environment.steamApiUrl}/third-party-apps/update-check`,
  thirdPartyAppsIsvUpdateCheck: `${environment.steamApiUrl}/third-party-apps/isv-update-check`,
  getThirdPartyAppsByUser:`${environment.apiUrl}/getThirdPartyAppsByUser`,
  isvMyApps: `${environment.steamApiUrl}/isv-my-apps`,
  isvMyAppPackageExists: `${environment.steamApiUrl}/isv-my-apps/package-exists`,
  addIsvApp: `${environment.steamApiUrl}/add-isv-app`,
  isvMyAppBuilds: `${environment.steamApiUrl}/app-to-build`,
  isvAppBuildUpload: `${environment.steamApiUrl}/app-to-build/upload`,
  getCustomerByIsv: `${environment.steamApiUrl}/get-customer-by-isv`,

  assign:{
    checkDowngrade:`${environment.apiUrl}/checkDowngradeBuild`
  },

  campaign: {
    url:`${environment.apiUrl}/campaign`,
    ui: `${environment.apiUrl}/campaign/ui`,
    assign: `${environment.apiUrl}/campaign/assign`,
    upload: `${environment.apiUrl}/campaign/signed-url`
  },
  notifyUser:`${environment.apiUrl}/notifyUser`,
  varsheetDocs: {
    upload: `${environment.apiUrl}/varsheet-docs/signed-url`
  },
  communicationCenter: {
    getOptions: `${environment.steamApiUrl}/communication/getCommunicationOptions`,
    triggerNotification: `${environment.steamApiUrl}/communication/triggerNats`,
    getControlTemplate: `${environment.cccApiUrl}/communication/getccctemplate`,
    emptyTemplate:`${environment.steamApiUrl}/`,
    sendNatsMessage:`${environment.cccApiUrl}/api/triggerNats`,
    triggerNats: `${environment.cccApiUrl}/communication/triggerNats`,
    cccJobs: `${environment.cccApiUrl}/communication/ccc-jobs`,
  },
  getENVConfig: `${environment.apiUrl}/bigdata-search`,
  getTermsTemplate : `${environment.apiUrl}/getTermsTemplate`,
  saveTermsAgreement:`${environment.apiUrl}/saveTermsAgreement`,
  loadTermsPdf : `${environment.apiUrl}/terms-pdf`,
  merchantBilling: {
    accountInfo: `${environment.apiUrl}/billing-account-info`,
    getContract: `${environment.apiUrl}/getMerchantContract`,
    saveSellingPrice: `${environment.apiUrl}/save-selling-price`,
    billingStatus: `${environment.apiUrl}/billing-status`,
    getBillingSummary: `${environment.apiUrl}/billing-summary`,
    bulkEnable: `${environment.apiUrl}/billing-bulk-enable`,
    paymentDetail: `${environment.apiUrl}/payment-detail`,
    billingEnableById: `${environment.apiUrl}/billingEnableById`,
    disableBilling: `${environment.apiUrl}/billingDisableById`,
    enableBilling: `${environment.apiUrl}/billingEnable`,
    consumerDetails:`${environment.apiUrl}/consumer-detail`,
    getInvoicesMonthly:`${environment.apiUrl}/merchant-billing-monthly-invoices`,
    getInvoiceIds:`${environment.apiUrl}/merchant-billing-invoices-ids`,
    getInvoiceDetails:`${environment.apiUrl}/merchant-billing-invoices-details`,
    invoiceDownload:`${environment.apiUrl}/invoice-download`,
    s3Link:`${environment.apiUrl}/get-s3-link`,
    getMerchant :`${environment.apiUrl}/getMerchantById/`
  },
  fetchAndPay: {
    getIntegratorData: `${environment.apiUrl}/fetch/getIntegratorData`,
    getIntegratorMappingData: `${environment.apiUrl}/fetch/getIntegratorMappingData/`,
    saveIntegratorData: `${environment.apiUrl}/fetch/saveIntegratorData`,
    getIntegratorConfig: `${environment.apiUrl}/fetch/getIntegratorConfig`,
    saveIsoIntegratorMappings: `${environment.apiUrl}/fetch/saveIsoIntegratorMappings`,
    disableMappings: `${environment.apiUrl}/fetch/disableMappings`,
    enableMappings: `${environment.apiUrl}/fetch/enableMappings`,
    updateTpnPosParams: `${environment.steamApiUrl}/bulkUpdateTpnDetails`,
    getIntegratorDetails: `${environment.apiUrl}/fetch/getIntergrator`,
    invoiceDetails: `${environment.apiUrl}/invoiceDetails`,
    saveInvoiceData: `${environment.apiUrl}/fetch/saveInvoiceData`
  },
  deleteInvoiceStatus : `${environment.apiUrl}/deleteInvoiceStatus`,
  markUsPaid : `${environment.apiUrl}/markUsPaid`,
  getSLNumberData: `${environment.apiUrl}/assets_details/getserialNumber`,
  verifyMarkAsPaid : `${environment.invoiceApiUrl}/invoice/verifyMarkAsPaid`,
  cancelPaymentLink : `${environment.invoiceApiUrl}/invoice/cancellPaymentLink`,
  gw : {
    pockytRefund: `${environment.apiUrl}/gw/pockyt-refund`
  },
  designerTool: {
    createTemplate: `${environment.apiUrl}/designer-tool/create-templates`,
    getAllTemplate: `${environment.apiUrl}/designer-tool/get-all-templates`,
    getTemplateById: `${environment.apiUrl}/designer-tool/template`,
    deleteTemplateById: `${environment.apiUrl}/designer-tool/template`,
    // getDesignById: `${environment.steamApiUrl}/designer-tool/getDesignById/`,
    // uploadAsset: `${environment.steamApiUrl}/uploadAsset`
  },
  loyalty: {
    getLoyaltyData: `${environment.apiUrl}/getLoyaltyData`,
    getLoyaltyProviderList: `${environment.apiUrl}/getLoyaltyProviderList`,
    saveLoyaltyProvider: `${environment.apiUrl}/saveLoyaltyProvider`,
    toggleLoyaltyProvider: `${environment.apiUrl}/toggleLoyaltyProvider`,
    toggleLoyaltyConfiguration: `${environment.apiUrl}/toggleLoyaltyConfiguration`,
    checkLoyaltyExists: `${environment.apiUrl}/checkLoyaltyExists`,
    bulkUpdateEnpAddAuditLog: `${environment.steamApiUrl}/bulkUpdateEnpAddAuditLog`,
    toggleTPNParams: `${environment.steamApiUrl}/toggleTPNParams`,
  },
  postLog:`${environment.apiUrl}/postLog`,
  getStoreByUser:`${environment.apiUrl}/stores-accessible`,

  newInvoice:{
    updateDraftedOrPendingInvoice: `${environment.apiUrl}/updateDraftedOrPendingInvoice`,
    canSendPaymentLink: `${environment.apiUrl}/canSendPaymentLink`,
    externalInvoiceCheckoutLock: `${environment.apiUrl}/externalInvoiceCheckoutLock`,
    reportPaymentUpdateFailure: `${environment.invoiceApiUrl}/invoice/reportPaymentUpdateFailure`,
    getInvoiceHistory: `${environment.invoiceApiUrl}/invoice/getChildInvoiceList`
  },
  achnxapis:{
    commonTransactionApi: `${environment.achApiUrl}/process-ach-payments`,
    commonAddBankApi: `${environment.achApiUrl}/add-bank`,
    tokenizedTransaction: `${environment.achApiUrl}/tokenized-transaction`,
  },
  veriCheckAch: {
    checkPaymentStatus: `${environment.achApiUrl}/vericheck/checkPaymentStatus`,
    checkRefundStatus: `${environment.achApiUrl}/vericheck/checkRefundStatus`,
    void: `${environment.achApiUrl}/alternateVoidTxn`,
    alternateVoidRefundTxn: `${environment.achApiUrl}/alternateVoidRefundTxn`,
    refund: `${environment.achApiUrl}/refund`,
  },
isv: {
    getIsv: `${environment.apiUrl}/isv/get-isv`,
    // Used only by the Edit Processor "Tag ISV" dialog's own list fetch (opened first, then
    // loaded with a skeleton state) — every other ISV-list consumer keeps using getIsv above.
    getIsvRestrict: `${environment.apiUrl}/isv/get-isv/restrict`,
    getCurrentIsv: `${environment.apiUrl}/isv/get-current-isv`,
    getIsvIntegration: `${environment.apiUrl}/isv/get-isv-integrations`,
    getIsvAddOns: `${environment.apiUrl}/isv/get-isv-addons`,
    createIsv: `${environment.apiUrl}/isv/create-isv`,
    updateIsv: `${environment.apiUrl}/isv/update-isv`,
    replaceIsvEmail: `${environment.apiUrl}/isv/replaceIsvEmail`,
    checkDba: `${environment.apiUrl}/isv/check-dba`,
    downloadIsv: `${environment.apiUrl}/isv/download-isv`,
    getSalesPersons: `${environment.apiUrl}/isv/getSalesPersons`,
    getIsvFeatures: `${environment.apiUrl}/isv/get-isv-features`,
    updateIsvFeatures: `${environment.apiUrl}/isv/update-isv-features`,
    deviceUrl: `${environment.apiUrl}/isv/ccc-tpns`,
  },

}
